<!--
  ~ Copyright (C) 2025 - Potentially Ltd
  ~
  ~ Please see distribution for license.
  -->

<div class="pie-chart-container" [class.is-v3]="variant === 'v3'">
  <div class="pie-chart-box">
    <canvas baseChart [datasets]="chartDataset" [labels]="chartLabels" [type]="chartType" [options]="chartOptions"></canvas>
  </div>

  <ul class="pie-chart-legend">
    <li *ngFor="let segment of pieSegments">
      <span class="legend-color" [style.background]="segment.color"></span>
      <span class="legend-label small">{{ segment.label }}</span>
      <span class="legend-value small bold">{{ segment.value }}</span>
    </li>
  </ul>
</div>
